module.exports = __webpack_public_path__ + "static/img/product_qmz.bc58771.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/product_qmz.png
// module id = Ltz8
// module chunks = 0